import { getWindowLocationValues } from './helpers'

/**
 * Track page view events
 *
 * @param {object} statsigClient
 * @param {object} event
 * @param {object} event.scope
 */
export function trackPageViewEvent(statsigClient, { scope }) {
  const path = scope?.path || window.location.pathname

  statsigClient?.logEvent('page_view', path, {
    title: scope?.title || document.title,
    ...getWindowLocationValues(scope),
  })
}
